<template>
  <div>
  	<!-- <header-prismic/> -->
    <hello-bar/>
    <header-netcore/>
    <router-view/>
    <footer-prismic/>
  </div>
</template>

<script>
  import HeaderNetcore from './components/HeaderNetcore.vue'
  import FooterPrismic from './components/FooterPrismic.vue'
  import HelloBar from './components/HelloBar.vue'

  export default {
    name: 'App',
    components: {
      FooterPrismic,
      HeaderNetcore,
      HelloBar
    }
  }
</script>

<style>
  @import "./assets/css/resetr.css";
  @import "./assets/css/prismic-edit-button.css";
</style>
